var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3a11"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3a11"] = parcelRequire;
}
// ONLY 1 CONTROLLER AND 1 MODEL.  MULTIPLE VIEWS SINCE THEY ARE MUCH BIGGER.  THIS SITS BETWEEN THE MODEL AND VIEW AND ACTS LIKE A "BRIDGE".
// events should be handled here in the controller.  Otherwise, there would be application logic in the view.  However, events need to be listened for in the view.  Otherwise, DOM elements would have to go in the controller, and presentation logic would be in the controller (goes against MVC).
// import everything in the model.  These are "named" exports since they are named.  So export everything and call it the "model".  write as model.state, model.recipe etc.
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
var $f6270ddd51c61def$exports = {};
var $c6205de543480f1d$exports = {};
var $c6205de543480f1d$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$c6205de543480f1d$exports = // eslint-disable-next-line es/no-global-this -- safe
$c6205de543480f1d$var$check(typeof globalThis == "object" && globalThis) || $c6205de543480f1d$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$c6205de543480f1d$var$check(typeof self == "object" && self) || $c6205de543480f1d$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || $c6205de543480f1d$exports || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $00890074abf92255$export$2d1720544b23b823;
var $51170708ab4a437d$exports = {};
var $e8a4bac282106998$exports = {};
$e8a4bac282106998$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$51170708ab4a437d$exports = !$e8a4bac282106998$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});


var $63966f276cc0fea7$exports = {};
var $4f774b6605c4a0ac$exports = {};

$4f774b6605c4a0ac$exports = !$e8a4bac282106998$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $63966f276cc0fea7$var$call = Function.prototype.call;
$63966f276cc0fea7$exports = $4f774b6605c4a0ac$exports ? $63966f276cc0fea7$var$call.bind($63966f276cc0fea7$var$call) : function() {
    return $63966f276cc0fea7$var$call.apply($63966f276cc0fea7$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $5a315bdcf60ddd45$export$2d1720544b23b823;
"use strict";
var $5a315bdcf60ddd45$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $5a315bdcf60ddd45$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $5a315bdcf60ddd45$var$NASHORN_BUG = $5a315bdcf60ddd45$var$getOwnPropertyDescriptor && !$5a315bdcf60ddd45$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$5a315bdcf60ddd45$export$2d1720544b23b823 = $5a315bdcf60ddd45$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $5a315bdcf60ddd45$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $5a315bdcf60ddd45$var$$propertyIsEnumerable;


var $ec46d9cdf095378d$exports = {};
$ec46d9cdf095378d$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $ebcaccf7448f34e5$exports = {};
// toObject with fallback for non-array-like ES3 strings
var $96335efd6eda8d57$exports = {};
var $fe2df9d36355ac17$exports = {};

var $fe2df9d36355ac17$var$FunctionPrototype = Function.prototype;
var $fe2df9d36355ac17$var$call = $fe2df9d36355ac17$var$FunctionPrototype.call;
var $fe2df9d36355ac17$var$uncurryThisWithBind = $4f774b6605c4a0ac$exports && $fe2df9d36355ac17$var$FunctionPrototype.bind.bind($fe2df9d36355ac17$var$call, $fe2df9d36355ac17$var$call);
$fe2df9d36355ac17$exports = $4f774b6605c4a0ac$exports ? $fe2df9d36355ac17$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $fe2df9d36355ac17$var$call.apply(fn, arguments);
    };
};



var $7a5e11be076ba008$exports = {};

var $7a5e11be076ba008$var$toString = $fe2df9d36355ac17$exports({}.toString);
var $7a5e11be076ba008$var$stringSlice = $fe2df9d36355ac17$exports("".slice);
$7a5e11be076ba008$exports = function(it) {
    return $7a5e11be076ba008$var$stringSlice($7a5e11be076ba008$var$toString(it), 8, -1);
};


var $96335efd6eda8d57$var$$Object = Object;
var $96335efd6eda8d57$var$split = $fe2df9d36355ac17$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$96335efd6eda8d57$exports = $e8a4bac282106998$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$96335efd6eda8d57$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $7a5e11be076ba008$exports(it) == "String" ? $96335efd6eda8d57$var$split(it, "") : $96335efd6eda8d57$var$$Object(it);
} : $96335efd6eda8d57$var$$Object;


var $cecb9fa1d25e2c04$exports = {};
var $853cbbbd12443d7d$exports = {};
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$853cbbbd12443d7d$exports = function(it) {
    return it === null || it === undefined;
};


var $cecb9fa1d25e2c04$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$cecb9fa1d25e2c04$exports = function(it) {
    if ($853cbbbd12443d7d$exports(it)) throw $cecb9fa1d25e2c04$var$$TypeError("Can't call method on " + it);
    return it;
};


$ebcaccf7448f34e5$exports = function(it) {
    return $96335efd6eda8d57$exports($cecb9fa1d25e2c04$exports(it));
};


var $ec538d1a3b10d3c6$exports = {};
var $9e2e2c95ff587201$exports = {};

var $20c300cc767ce923$exports = {};
var $6e74dcd3287ee980$exports = {};
var $795ef7c21eddbd2e$exports = {};
var $795ef7c21eddbd2e$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $795ef7c21eddbd2e$var$IS_HTMLDDA = typeof $795ef7c21eddbd2e$var$documentAll == "undefined" && $795ef7c21eddbd2e$var$documentAll !== undefined;
$795ef7c21eddbd2e$exports = {
    all: $795ef7c21eddbd2e$var$documentAll,
    IS_HTMLDDA: $795ef7c21eddbd2e$var$IS_HTMLDDA
};


var $6e74dcd3287ee980$var$documentAll = $795ef7c21eddbd2e$exports.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$6e74dcd3287ee980$exports = $795ef7c21eddbd2e$exports.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $6e74dcd3287ee980$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};



var $20c300cc767ce923$var$documentAll = $795ef7c21eddbd2e$exports.all;
$20c300cc767ce923$exports = $795ef7c21eddbd2e$exports.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $6e74dcd3287ee980$exports(it) || it === $20c300cc767ce923$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $6e74dcd3287ee980$exports(it);
};


var $554e1721bcf0df7b$exports = {};
var $4116c9b730824ca5$exports = {};


var $4116c9b730824ca5$var$aFunction = function(argument) {
    return $6e74dcd3287ee980$exports(argument) ? argument : undefined;
};
$4116c9b730824ca5$exports = function(namespace, method) {
    return arguments.length < 2 ? $4116c9b730824ca5$var$aFunction($c6205de543480f1d$exports[namespace]) : $c6205de543480f1d$exports[namespace] && $c6205de543480f1d$exports[namespace][method];
};



var $2f9342a57fb60c81$exports = {};

$2f9342a57fb60c81$exports = $fe2df9d36355ac17$exports({}.isPrototypeOf);


var $5f3daa342c038926$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $d0d9bf2a44b73284$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $68b95f0d440f984b$exports = {};

var $4b763539b040e8c7$exports = {};
$4b763539b040e8c7$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $68b95f0d440f984b$var$process = $c6205de543480f1d$exports.process;
var $68b95f0d440f984b$var$Deno = $c6205de543480f1d$exports.Deno;
var $68b95f0d440f984b$var$versions = $68b95f0d440f984b$var$process && $68b95f0d440f984b$var$process.versions || $68b95f0d440f984b$var$Deno && $68b95f0d440f984b$var$Deno.version;
var $68b95f0d440f984b$var$v8 = $68b95f0d440f984b$var$versions && $68b95f0d440f984b$var$versions.v8;
var $68b95f0d440f984b$var$match, $68b95f0d440f984b$var$version;
if ($68b95f0d440f984b$var$v8) {
    $68b95f0d440f984b$var$match = $68b95f0d440f984b$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $68b95f0d440f984b$var$version = $68b95f0d440f984b$var$match[0] > 0 && $68b95f0d440f984b$var$match[0] < 4 ? 1 : +($68b95f0d440f984b$var$match[0] + $68b95f0d440f984b$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$68b95f0d440f984b$var$version && $4b763539b040e8c7$exports) {
    $68b95f0d440f984b$var$match = $4b763539b040e8c7$exports.match(/Edge\/(\d+)/);
    if (!$68b95f0d440f984b$var$match || $68b95f0d440f984b$var$match[1] >= 74) {
        $68b95f0d440f984b$var$match = $4b763539b040e8c7$exports.match(/Chrome\/(\d+)/);
        if ($68b95f0d440f984b$var$match) $68b95f0d440f984b$var$version = +$68b95f0d440f984b$var$match[1];
    }
}
$68b95f0d440f984b$exports = $68b95f0d440f984b$var$version;




var $d0d9bf2a44b73284$var$$String = $c6205de543480f1d$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$d0d9bf2a44b73284$exports = !!Object.getOwnPropertySymbols && !$e8a4bac282106998$exports(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$d0d9bf2a44b73284$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $68b95f0d440f984b$exports && $68b95f0d440f984b$exports < 41;
});


$5f3daa342c038926$exports = $d0d9bf2a44b73284$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $554e1721bcf0df7b$var$$Object = Object;
$554e1721bcf0df7b$exports = $5f3daa342c038926$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $4116c9b730824ca5$exports("Symbol");
    return $6e74dcd3287ee980$exports($Symbol) && $2f9342a57fb60c81$exports($Symbol.prototype, $554e1721bcf0df7b$var$$Object(it));
};


var $c719ee9a216b866b$exports = {};
var $fb2281937471b286$exports = {};

var $e089eb0fde93241f$exports = {};
var $e089eb0fde93241f$var$$String = String;
$e089eb0fde93241f$exports = function(argument) {
    try {
        return $e089eb0fde93241f$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $fb2281937471b286$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$fb2281937471b286$exports = function(argument) {
    if ($6e74dcd3287ee980$exports(argument)) return argument;
    throw $fb2281937471b286$var$$TypeError($e089eb0fde93241f$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$c719ee9a216b866b$exports = function(V, P) {
    var func = V[P];
    return $853cbbbd12443d7d$exports(func) ? undefined : $fb2281937471b286$exports(func);
};


var $e8ac32edf1214c29$exports = {};



var $e8ac32edf1214c29$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$e8ac32edf1214c29$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $6e74dcd3287ee980$exports(fn = input.toString) && !$20c300cc767ce923$exports(val = $63966f276cc0fea7$exports(fn, input))) return val;
    if ($6e74dcd3287ee980$exports(fn = input.valueOf) && !$20c300cc767ce923$exports(val = $63966f276cc0fea7$exports(fn, input))) return val;
    if (pref !== "string" && $6e74dcd3287ee980$exports(fn = input.toString) && !$20c300cc767ce923$exports(val = $63966f276cc0fea7$exports(fn, input))) return val;
    throw $e8ac32edf1214c29$var$$TypeError("Can't convert object to primitive value");
};


var $b56c9ac29d16e10b$exports = {};

var $d83a0c9decd7b664$exports = {};
var $8d66e01ffd74a162$exports = {};
$8d66e01ffd74a162$exports = false;


var $0959a1e68670024d$exports = {};

var $5aa38552f2a3b7b0$exports = {};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $5aa38552f2a3b7b0$var$defineProperty = Object.defineProperty;
$5aa38552f2a3b7b0$exports = function(key, value) {
    try {
        $5aa38552f2a3b7b0$var$defineProperty($c6205de543480f1d$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $c6205de543480f1d$exports[key] = value;
    }
    return value;
};


var $0959a1e68670024d$var$SHARED = "__core-js_shared__";
var $0959a1e68670024d$var$store = $c6205de543480f1d$exports[$0959a1e68670024d$var$SHARED] || $5aa38552f2a3b7b0$exports($0959a1e68670024d$var$SHARED, {});
$0959a1e68670024d$exports = $0959a1e68670024d$var$store;


($d83a0c9decd7b664$exports = function(key, value) {
    return $0959a1e68670024d$exports[key] || ($0959a1e68670024d$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.31.1",
    mode: $8d66e01ffd74a162$exports ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.31.1/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


var $c51418e3dd02e981$exports = {};

var $c73014588f4ce318$exports = {};

var $c73014588f4ce318$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$c73014588f4ce318$exports = function(argument) {
    return $c73014588f4ce318$var$$Object($cecb9fa1d25e2c04$exports(argument));
};


var $c51418e3dd02e981$var$hasOwnProperty = $fe2df9d36355ac17$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$c51418e3dd02e981$exports = Object.hasOwn || function hasOwn(it, key) {
    return $c51418e3dd02e981$var$hasOwnProperty($c73014588f4ce318$exports(it), key);
};


var $c1521085f1986487$exports = {};

var $c1521085f1986487$var$id = 0;
var $c1521085f1986487$var$postfix = Math.random();
var $c1521085f1986487$var$toString = $fe2df9d36355ac17$exports(1.0.toString);
$c1521085f1986487$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $c1521085f1986487$var$toString(++$c1521085f1986487$var$id + $c1521085f1986487$var$postfix, 36);
};




var $b56c9ac29d16e10b$var$Symbol = $c6205de543480f1d$exports.Symbol;
var $b56c9ac29d16e10b$var$WellKnownSymbolsStore = $d83a0c9decd7b664$exports("wks");
var $b56c9ac29d16e10b$var$createWellKnownSymbol = $5f3daa342c038926$exports ? $b56c9ac29d16e10b$var$Symbol["for"] || $b56c9ac29d16e10b$var$Symbol : $b56c9ac29d16e10b$var$Symbol && $b56c9ac29d16e10b$var$Symbol.withoutSetter || $c1521085f1986487$exports;
$b56c9ac29d16e10b$exports = function(name) {
    if (!$c51418e3dd02e981$exports($b56c9ac29d16e10b$var$WellKnownSymbolsStore, name)) $b56c9ac29d16e10b$var$WellKnownSymbolsStore[name] = $d0d9bf2a44b73284$exports && $c51418e3dd02e981$exports($b56c9ac29d16e10b$var$Symbol, name) ? $b56c9ac29d16e10b$var$Symbol[name] : $b56c9ac29d16e10b$var$createWellKnownSymbol("Symbol." + name);
    return $b56c9ac29d16e10b$var$WellKnownSymbolsStore[name];
};


var $9e2e2c95ff587201$var$$TypeError = TypeError;
var $9e2e2c95ff587201$var$TO_PRIMITIVE = $b56c9ac29d16e10b$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$9e2e2c95ff587201$exports = function(input, pref) {
    if (!$20c300cc767ce923$exports(input) || $554e1721bcf0df7b$exports(input)) return input;
    var exoticToPrim = $c719ee9a216b866b$exports(input, $9e2e2c95ff587201$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $63966f276cc0fea7$exports(exoticToPrim, input, pref);
        if (!$20c300cc767ce923$exports(result) || $554e1721bcf0df7b$exports(result)) return result;
        throw $9e2e2c95ff587201$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $e8ac32edf1214c29$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$ec538d1a3b10d3c6$exports = function(argument) {
    var key = $9e2e2c95ff587201$exports(argument, "string");
    return $554e1721bcf0df7b$exports(key) ? key : key + "";
};



var $5b4b5e9fa7281d94$exports = {};


var $b6e37854b5d2098b$exports = {};


var $b6e37854b5d2098b$var$document = $c6205de543480f1d$exports.document;
// typeof document.createElement is 'object' in old IE
var $b6e37854b5d2098b$var$EXISTS = $20c300cc767ce923$exports($b6e37854b5d2098b$var$document) && $20c300cc767ce923$exports($b6e37854b5d2098b$var$document.createElement);
$b6e37854b5d2098b$exports = function(it) {
    return $b6e37854b5d2098b$var$EXISTS ? $b6e37854b5d2098b$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$5b4b5e9fa7281d94$exports = !$51170708ab4a437d$exports && !$e8a4bac282106998$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($b6e37854b5d2098b$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $00890074abf92255$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$00890074abf92255$export$2d1720544b23b823 = $51170708ab4a437d$exports ? $00890074abf92255$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $ebcaccf7448f34e5$exports(O);
    P = $ec538d1a3b10d3c6$exports(P);
    if ($5b4b5e9fa7281d94$exports) try {
        return $00890074abf92255$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($c51418e3dd02e981$exports(O, P)) return $ec46d9cdf095378d$exports(!$63966f276cc0fea7$exports($5a315bdcf60ddd45$export$2d1720544b23b823, O, P), O[P]);
};


var $f6270ddd51c61def$require$getOwnPropertyDescriptor = $00890074abf92255$export$2d1720544b23b823;
var $da10e910c148380d$exports = {};

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $45ba22c346ded26d$export$2d1720544b23b823;


var $ccd829d42bcecb88$exports = {};


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$ccd829d42bcecb88$exports = $51170708ab4a437d$exports && $e8a4bac282106998$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});


var $dd79557b482f584b$exports = {};

var $dd79557b482f584b$var$$String = String;
var $dd79557b482f584b$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$dd79557b482f584b$exports = function(argument) {
    if ($20c300cc767ce923$exports(argument)) return argument;
    throw $dd79557b482f584b$var$$TypeError($dd79557b482f584b$var$$String(argument) + " is not an object");
};



var $45ba22c346ded26d$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $45ba22c346ded26d$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $45ba22c346ded26d$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $45ba22c346ded26d$var$ENUMERABLE = "enumerable";
var $45ba22c346ded26d$var$CONFIGURABLE = "configurable";
var $45ba22c346ded26d$var$WRITABLE = "writable";
$45ba22c346ded26d$export$2d1720544b23b823 = $51170708ab4a437d$exports ? $ccd829d42bcecb88$exports ? function defineProperty(O, P, Attributes) {
    $dd79557b482f584b$exports(O);
    P = $ec538d1a3b10d3c6$exports(P);
    $dd79557b482f584b$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $45ba22c346ded26d$var$WRITABLE in Attributes && !Attributes[$45ba22c346ded26d$var$WRITABLE]) {
        var current = $45ba22c346ded26d$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$45ba22c346ded26d$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $45ba22c346ded26d$var$CONFIGURABLE in Attributes ? Attributes[$45ba22c346ded26d$var$CONFIGURABLE] : current[$45ba22c346ded26d$var$CONFIGURABLE],
                enumerable: $45ba22c346ded26d$var$ENUMERABLE in Attributes ? Attributes[$45ba22c346ded26d$var$ENUMERABLE] : current[$45ba22c346ded26d$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $45ba22c346ded26d$var$$defineProperty(O, P, Attributes);
} : $45ba22c346ded26d$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $dd79557b482f584b$exports(O);
    P = $ec538d1a3b10d3c6$exports(P);
    $dd79557b482f584b$exports(Attributes);
    if ($5b4b5e9fa7281d94$exports) try {
        return $45ba22c346ded26d$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $45ba22c346ded26d$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$da10e910c148380d$exports = $51170708ab4a437d$exports ? function(object, key, value) {
    return $45ba22c346ded26d$export$2d1720544b23b823(object, key, $ec46d9cdf095378d$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $90395b2e6c4ecb12$exports = {};


var $070152f93a222320$exports = {};





var $5052059b258d897f$exports = {};


var $5052059b258d897f$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $5052059b258d897f$var$getDescriptor = $51170708ab4a437d$exports && Object.getOwnPropertyDescriptor;
var $5052059b258d897f$var$EXISTS = $c51418e3dd02e981$exports($5052059b258d897f$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $5052059b258d897f$var$PROPER = $5052059b258d897f$var$EXISTS && (function something() {}).name === "something";
var $5052059b258d897f$var$CONFIGURABLE = $5052059b258d897f$var$EXISTS && (!$51170708ab4a437d$exports || $51170708ab4a437d$exports && $5052059b258d897f$var$getDescriptor($5052059b258d897f$var$FunctionPrototype, "name").configurable);
$5052059b258d897f$exports = {
    EXISTS: $5052059b258d897f$var$EXISTS,
    PROPER: $5052059b258d897f$var$PROPER,
    CONFIGURABLE: $5052059b258d897f$var$CONFIGURABLE
};


var $070152f93a222320$require$CONFIGURABLE_FUNCTION_NAME = $5052059b258d897f$exports.CONFIGURABLE;
var $175d8501a266c412$exports = {};



var $175d8501a266c412$var$functionToString = $fe2df9d36355ac17$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$6e74dcd3287ee980$exports($0959a1e68670024d$exports.inspectSource)) $0959a1e68670024d$exports.inspectSource = function(it) {
    return $175d8501a266c412$var$functionToString(it);
};
$175d8501a266c412$exports = $0959a1e68670024d$exports.inspectSource;


var $f6d7471d9cc06975$exports = {};
var $d1d1569aba236793$exports = {};


var $d1d1569aba236793$var$WeakMap = $c6205de543480f1d$exports.WeakMap;
$d1d1569aba236793$exports = $6e74dcd3287ee980$exports($d1d1569aba236793$var$WeakMap) && /native code/.test(String($d1d1569aba236793$var$WeakMap));







var $b537a67fb868ce59$exports = {};


var $b537a67fb868ce59$var$keys = $d83a0c9decd7b664$exports("keys");
$b537a67fb868ce59$exports = function(key) {
    return $b537a67fb868ce59$var$keys[key] || ($b537a67fb868ce59$var$keys[key] = $c1521085f1986487$exports(key));
};


var $2f8184c5a9e86a5d$exports = {};
$2f8184c5a9e86a5d$exports = {};


var $f6d7471d9cc06975$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $f6d7471d9cc06975$var$TypeError = $c6205de543480f1d$exports.TypeError;
var $f6d7471d9cc06975$var$WeakMap = $c6205de543480f1d$exports.WeakMap;
var $f6d7471d9cc06975$var$set, $f6d7471d9cc06975$var$get, $f6d7471d9cc06975$var$has;
var $f6d7471d9cc06975$var$enforce = function(it) {
    return $f6d7471d9cc06975$var$has(it) ? $f6d7471d9cc06975$var$get(it) : $f6d7471d9cc06975$var$set(it, {});
};
var $f6d7471d9cc06975$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$20c300cc767ce923$exports(it) || (state = $f6d7471d9cc06975$var$get(it)).type !== TYPE) throw $f6d7471d9cc06975$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($d1d1569aba236793$exports || $0959a1e68670024d$exports.state) {
    var $f6d7471d9cc06975$var$store = $0959a1e68670024d$exports.state || ($0959a1e68670024d$exports.state = new $f6d7471d9cc06975$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $f6d7471d9cc06975$var$store.get = $f6d7471d9cc06975$var$store.get;
    $f6d7471d9cc06975$var$store.has = $f6d7471d9cc06975$var$store.has;
    $f6d7471d9cc06975$var$store.set = $f6d7471d9cc06975$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $f6d7471d9cc06975$var$set = function(it, metadata) {
        if ($f6d7471d9cc06975$var$store.has(it)) throw $f6d7471d9cc06975$var$TypeError($f6d7471d9cc06975$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $f6d7471d9cc06975$var$store.set(it, metadata);
        return metadata;
    };
    $f6d7471d9cc06975$var$get = function(it) {
        return $f6d7471d9cc06975$var$store.get(it) || {};
    };
    $f6d7471d9cc06975$var$has = function(it) {
        return $f6d7471d9cc06975$var$store.has(it);
    };
} else {
    var $f6d7471d9cc06975$var$STATE = $b537a67fb868ce59$exports("state");
    $2f8184c5a9e86a5d$exports[$f6d7471d9cc06975$var$STATE] = true;
    $f6d7471d9cc06975$var$set = function(it, metadata) {
        if ($c51418e3dd02e981$exports(it, $f6d7471d9cc06975$var$STATE)) throw $f6d7471d9cc06975$var$TypeError($f6d7471d9cc06975$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $da10e910c148380d$exports(it, $f6d7471d9cc06975$var$STATE, metadata);
        return metadata;
    };
    $f6d7471d9cc06975$var$get = function(it) {
        return $c51418e3dd02e981$exports(it, $f6d7471d9cc06975$var$STATE) ? it[$f6d7471d9cc06975$var$STATE] : {};
    };
    $f6d7471d9cc06975$var$has = function(it) {
        return $c51418e3dd02e981$exports(it, $f6d7471d9cc06975$var$STATE);
    };
}
$f6d7471d9cc06975$exports = {
    set: $f6d7471d9cc06975$var$set,
    get: $f6d7471d9cc06975$var$get,
    has: $f6d7471d9cc06975$var$has,
    enforce: $f6d7471d9cc06975$var$enforce,
    getterFor: $f6d7471d9cc06975$var$getterFor
};


var $070152f93a222320$var$enforceInternalState = $f6d7471d9cc06975$exports.enforce;
var $070152f93a222320$var$getInternalState = $f6d7471d9cc06975$exports.get;
var $070152f93a222320$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $070152f93a222320$var$defineProperty = Object.defineProperty;
var $070152f93a222320$var$stringSlice = $fe2df9d36355ac17$exports("".slice);
var $070152f93a222320$var$replace = $fe2df9d36355ac17$exports("".replace);
var $070152f93a222320$var$join = $fe2df9d36355ac17$exports([].join);
var $070152f93a222320$var$CONFIGURABLE_LENGTH = $51170708ab4a437d$exports && !$e8a4bac282106998$exports(function() {
    return $070152f93a222320$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $070152f93a222320$var$TEMPLATE = String(String).split("String");
var $070152f93a222320$var$makeBuiltIn = $070152f93a222320$exports = function(value, name, options) {
    if ($070152f93a222320$var$stringSlice($070152f93a222320$var$$String(name), 0, 7) === "Symbol(") name = "[" + $070152f93a222320$var$replace($070152f93a222320$var$$String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$c51418e3dd02e981$exports(value, "name") || $070152f93a222320$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($51170708ab4a437d$exports) $070152f93a222320$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($070152f93a222320$var$CONFIGURABLE_LENGTH && options && $c51418e3dd02e981$exports(options, "arity") && value.length !== options.arity) $070152f93a222320$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $c51418e3dd02e981$exports(options, "constructor") && options.constructor) {
            if ($51170708ab4a437d$exports) $070152f93a222320$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $070152f93a222320$var$enforceInternalState(value);
    if (!$c51418e3dd02e981$exports(state, "source")) state.source = $070152f93a222320$var$join($070152f93a222320$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $070152f93a222320$var$makeBuiltIn(function toString() {
    return $6e74dcd3287ee980$exports(this) && $070152f93a222320$var$getInternalState(this).source || $175d8501a266c412$exports(this);
}, "toString");



$90395b2e6c4ecb12$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($6e74dcd3287ee980$exports(value)) $070152f93a222320$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $5aa38552f2a3b7b0$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $45ba22c346ded26d$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $8c978a134f6ab899$exports = {};

var $4c9a983d2c8fa11e$exports = {};


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $3283e0995045c1cb$export$2d1720544b23b823;
var $1436dffeac2a903a$exports = {};



var $dd183100476846f7$exports = {};

var $f549756c917f7c67$exports = {};
var $d304d160fcb02df5$exports = {};
var $5d6011a8fb2100a5$exports = {};
var $5d6011a8fb2100a5$var$ceil = Math.ceil;
var $5d6011a8fb2100a5$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$5d6011a8fb2100a5$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5d6011a8fb2100a5$var$floor : $5d6011a8fb2100a5$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$d304d160fcb02df5$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $5d6011a8fb2100a5$exports(number);
};


var $f549756c917f7c67$var$max = Math.max;
var $f549756c917f7c67$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$f549756c917f7c67$exports = function(index, length) {
    var integer = $d304d160fcb02df5$exports(index);
    return integer < 0 ? $f549756c917f7c67$var$max(integer + length, 0) : $f549756c917f7c67$var$min(integer, length);
};


var $e465503e58c2e549$exports = {};
var $3b38ad228bf4f1d5$exports = {};

var $3b38ad228bf4f1d5$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$3b38ad228bf4f1d5$exports = function(argument) {
    return argument > 0 ? $3b38ad228bf4f1d5$var$min($d304d160fcb02df5$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$e465503e58c2e549$exports = function(obj) {
    return $3b38ad228bf4f1d5$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $dd183100476846f7$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $ebcaccf7448f34e5$exports($this);
        var length = $e465503e58c2e549$exports(O);
        var index = $f549756c917f7c67$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$dd183100476846f7$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $dd183100476846f7$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $dd183100476846f7$var$createMethod(false)
};


var $1436dffeac2a903a$require$indexOf = $dd183100476846f7$exports.indexOf;

var $1436dffeac2a903a$var$push = $fe2df9d36355ac17$exports([].push);
$1436dffeac2a903a$exports = function(object, names) {
    var O = $ebcaccf7448f34e5$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$c51418e3dd02e981$exports($2f8184c5a9e86a5d$exports, key) && $c51418e3dd02e981$exports(O, key) && $1436dffeac2a903a$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($c51418e3dd02e981$exports(O, key = names[i++])) ~$1436dffeac2a903a$require$indexOf(result, key) || $1436dffeac2a903a$var$push(result, key);
    return result;
};


var $466dde65ffd8b925$exports = {};
// IE8- don't enum bug keys
$466dde65ffd8b925$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $3283e0995045c1cb$var$hiddenKeys = $466dde65ffd8b925$exports.concat("length", "prototype");
$3283e0995045c1cb$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $1436dffeac2a903a$exports(O, $3283e0995045c1cb$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $42e7565a3f90380f$export$2d1720544b23b823;
$42e7565a3f90380f$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $4c9a983d2c8fa11e$var$concat = $fe2df9d36355ac17$exports([].concat);
// all object keys, includes non-enumerable and symbols
$4c9a983d2c8fa11e$exports = $4116c9b730824ca5$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $3283e0995045c1cb$export$2d1720544b23b823($dd79557b482f584b$exports(it));
    var getOwnPropertySymbols = $42e7565a3f90380f$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $4c9a983d2c8fa11e$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$8c978a134f6ab899$exports = function(target, source, exceptions) {
    var keys = $4c9a983d2c8fa11e$exports(source);
    var defineProperty = $45ba22c346ded26d$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $00890074abf92255$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$c51418e3dd02e981$exports(target, key) && !(exceptions && $c51418e3dd02e981$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $f264796d5a4f0418$exports = {};


var $f264796d5a4f0418$var$replacement = /#|\.prototype\./;
var $f264796d5a4f0418$var$isForced = function(feature, detection) {
    var value = $f264796d5a4f0418$var$data[$f264796d5a4f0418$var$normalize(feature)];
    return value == $f264796d5a4f0418$var$POLYFILL ? true : value == $f264796d5a4f0418$var$NATIVE ? false : $6e74dcd3287ee980$exports(detection) ? $e8a4bac282106998$exports(detection) : !!detection;
};
var $f264796d5a4f0418$var$normalize = $f264796d5a4f0418$var$isForced.normalize = function(string) {
    return String(string).replace($f264796d5a4f0418$var$replacement, ".").toLowerCase();
};
var $f264796d5a4f0418$var$data = $f264796d5a4f0418$var$isForced.data = {};
var $f264796d5a4f0418$var$NATIVE = $f264796d5a4f0418$var$isForced.NATIVE = "N";
var $f264796d5a4f0418$var$POLYFILL = $f264796d5a4f0418$var$isForced.POLYFILL = "P";
$f264796d5a4f0418$exports = $f264796d5a4f0418$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $f6270ddd51c61def$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $c6205de543480f1d$exports;
    else if (STATIC) target = $c6205de543480f1d$exports[TARGET] || $5aa38552f2a3b7b0$exports(TARGET, {});
    else target = ($c6205de543480f1d$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $f6270ddd51c61def$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $f264796d5a4f0418$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $8c978a134f6ab899$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $da10e910c148380d$exports(sourceProperty, "sham", true);
        $90395b2e6c4ecb12$exports(target, key, sourceProperty, options);
    }
};



var $56173b32960dbab3$exports = {};

var $6c5bdeeed6ccae75$exports = {};

var $6c5bdeeed6ccae75$var$FunctionPrototype = Function.prototype;
var $6c5bdeeed6ccae75$var$apply = $6c5bdeeed6ccae75$var$FunctionPrototype.apply;
var $6c5bdeeed6ccae75$var$call = $6c5bdeeed6ccae75$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$6c5bdeeed6ccae75$exports = typeof Reflect == "object" && Reflect.apply || ($4f774b6605c4a0ac$exports ? $6c5bdeeed6ccae75$var$call.bind($6c5bdeeed6ccae75$var$apply) : function() {
    return $6c5bdeeed6ccae75$var$call.apply($6c5bdeeed6ccae75$var$apply, arguments);
});


var $817a439101a0a4a9$exports = {};
var $476035ee5b3e3daf$exports = {};


$476035ee5b3e3daf$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($7a5e11be076ba008$exports(fn) === "Function") return $fe2df9d36355ac17$exports(fn);
};




var $817a439101a0a4a9$var$bind = $476035ee5b3e3daf$exports($476035ee5b3e3daf$exports.bind);
// optional / simple context binding
$817a439101a0a4a9$exports = function(fn, that) {
    $fb2281937471b286$exports(fn);
    return that === undefined ? fn : $4f774b6605c4a0ac$exports ? $817a439101a0a4a9$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $8bdfb5d01b9c29df$exports = {};

$8bdfb5d01b9c29df$exports = $4116c9b730824ca5$exports("document", "documentElement");


var $1b52762827a188f4$exports = {};

$1b52762827a188f4$exports = $fe2df9d36355ac17$exports([].slice);



var $7cf165f1a18eedff$exports = {};
var $7cf165f1a18eedff$var$$TypeError = TypeError;
$7cf165f1a18eedff$exports = function(passed, required) {
    if (passed < required) throw $7cf165f1a18eedff$var$$TypeError("Not enough arguments");
    return passed;
};


var $79dce65a5d9fb51a$exports = {};

// eslint-disable-next-line redos/no-vulnerable -- safe
$79dce65a5d9fb51a$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($4b763539b040e8c7$exports);


var $def3e28ccc92020a$exports = {};
var $7dc779418f94dc56$exports = {};
// shim for using process in browser
var $7dc779418f94dc56$var$process = $7dc779418f94dc56$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $7dc779418f94dc56$var$cachedSetTimeout;
var $7dc779418f94dc56$var$cachedClearTimeout;
function $7dc779418f94dc56$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $7dc779418f94dc56$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $7dc779418f94dc56$var$cachedSetTimeout = setTimeout;
        else $7dc779418f94dc56$var$cachedSetTimeout = $7dc779418f94dc56$var$defaultSetTimout;
    } catch (e) {
        $7dc779418f94dc56$var$cachedSetTimeout = $7dc779418f94dc56$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $7dc779418f94dc56$var$cachedClearTimeout = clearTimeout;
        else $7dc779418f94dc56$var$cachedClearTimeout = $7dc779418f94dc56$var$defaultClearTimeout;
    } catch (e) {
        $7dc779418f94dc56$var$cachedClearTimeout = $7dc779418f94dc56$var$defaultClearTimeout;
    }
})();
function $7dc779418f94dc56$var$runTimeout(fun) {
    if ($7dc779418f94dc56$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($7dc779418f94dc56$var$cachedSetTimeout === $7dc779418f94dc56$var$defaultSetTimout || !$7dc779418f94dc56$var$cachedSetTimeout) && setTimeout) {
        $7dc779418f94dc56$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7dc779418f94dc56$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $7dc779418f94dc56$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $7dc779418f94dc56$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $7dc779418f94dc56$var$runClearTimeout(marker) {
    if ($7dc779418f94dc56$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($7dc779418f94dc56$var$cachedClearTimeout === $7dc779418f94dc56$var$defaultClearTimeout || !$7dc779418f94dc56$var$cachedClearTimeout) && clearTimeout) {
        $7dc779418f94dc56$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7dc779418f94dc56$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $7dc779418f94dc56$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $7dc779418f94dc56$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $7dc779418f94dc56$var$queue = [];
var $7dc779418f94dc56$var$draining = false;
var $7dc779418f94dc56$var$currentQueue;
var $7dc779418f94dc56$var$queueIndex = -1;
function $7dc779418f94dc56$var$cleanUpNextTick() {
    if (!$7dc779418f94dc56$var$draining || !$7dc779418f94dc56$var$currentQueue) return;
    $7dc779418f94dc56$var$draining = false;
    if ($7dc779418f94dc56$var$currentQueue.length) $7dc779418f94dc56$var$queue = $7dc779418f94dc56$var$currentQueue.concat($7dc779418f94dc56$var$queue);
    else $7dc779418f94dc56$var$queueIndex = -1;
    if ($7dc779418f94dc56$var$queue.length) $7dc779418f94dc56$var$drainQueue();
}
function $7dc779418f94dc56$var$drainQueue() {
    if ($7dc779418f94dc56$var$draining) return;
    var timeout = $7dc779418f94dc56$var$runTimeout($7dc779418f94dc56$var$cleanUpNextTick);
    $7dc779418f94dc56$var$draining = true;
    var len = $7dc779418f94dc56$var$queue.length;
    while(len){
        $7dc779418f94dc56$var$currentQueue = $7dc779418f94dc56$var$queue;
        $7dc779418f94dc56$var$queue = [];
        while(++$7dc779418f94dc56$var$queueIndex < len)if ($7dc779418f94dc56$var$currentQueue) $7dc779418f94dc56$var$currentQueue[$7dc779418f94dc56$var$queueIndex].run();
        $7dc779418f94dc56$var$queueIndex = -1;
        len = $7dc779418f94dc56$var$queue.length;
    }
    $7dc779418f94dc56$var$currentQueue = null;
    $7dc779418f94dc56$var$draining = false;
    $7dc779418f94dc56$var$runClearTimeout(timeout);
}
$7dc779418f94dc56$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $7dc779418f94dc56$var$queue.push(new $7dc779418f94dc56$var$Item(fun, args));
    if ($7dc779418f94dc56$var$queue.length === 1 && !$7dc779418f94dc56$var$draining) $7dc779418f94dc56$var$runTimeout($7dc779418f94dc56$var$drainQueue);
};
// v8 likes predictible objects
function $7dc779418f94dc56$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$7dc779418f94dc56$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$7dc779418f94dc56$var$process.title = "browser";
$7dc779418f94dc56$var$process.browser = true;
$7dc779418f94dc56$var$process.env = {};
$7dc779418f94dc56$var$process.argv = [];
$7dc779418f94dc56$var$process.version = ""; // empty string to avoid regexp issues
$7dc779418f94dc56$var$process.versions = {};
function $7dc779418f94dc56$var$noop() {}
$7dc779418f94dc56$var$process.on = $7dc779418f94dc56$var$noop;
$7dc779418f94dc56$var$process.addListener = $7dc779418f94dc56$var$noop;
$7dc779418f94dc56$var$process.once = $7dc779418f94dc56$var$noop;
$7dc779418f94dc56$var$process.off = $7dc779418f94dc56$var$noop;
$7dc779418f94dc56$var$process.removeListener = $7dc779418f94dc56$var$noop;
$7dc779418f94dc56$var$process.removeAllListeners = $7dc779418f94dc56$var$noop;
$7dc779418f94dc56$var$process.emit = $7dc779418f94dc56$var$noop;
$7dc779418f94dc56$var$process.prependListener = $7dc779418f94dc56$var$noop;
$7dc779418f94dc56$var$process.prependOnceListener = $7dc779418f94dc56$var$noop;
$7dc779418f94dc56$var$process.listeners = function(name) {
    return [];
};
$7dc779418f94dc56$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$7dc779418f94dc56$var$process.cwd = function() {
    return "/";
};
$7dc779418f94dc56$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$7dc779418f94dc56$var$process.umask = function() {
    return 0;
};



$def3e28ccc92020a$exports = typeof $7dc779418f94dc56$exports != "undefined" && $7a5e11be076ba008$exports($7dc779418f94dc56$exports) == "process";


var $56173b32960dbab3$var$set = $c6205de543480f1d$exports.setImmediate;
var $56173b32960dbab3$var$clear = $c6205de543480f1d$exports.clearImmediate;
var $56173b32960dbab3$var$process = $c6205de543480f1d$exports.process;
var $56173b32960dbab3$var$Dispatch = $c6205de543480f1d$exports.Dispatch;
var $56173b32960dbab3$var$Function = $c6205de543480f1d$exports.Function;
var $56173b32960dbab3$var$MessageChannel = $c6205de543480f1d$exports.MessageChannel;
var $56173b32960dbab3$var$String = $c6205de543480f1d$exports.String;
var $56173b32960dbab3$var$counter = 0;
var $56173b32960dbab3$var$queue = {};
var $56173b32960dbab3$var$ONREADYSTATECHANGE = "onreadystatechange";
var $56173b32960dbab3$var$$location, $56173b32960dbab3$var$defer, $56173b32960dbab3$var$channel, $56173b32960dbab3$var$port;
$e8a4bac282106998$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $56173b32960dbab3$var$$location = $c6205de543480f1d$exports.location;
});
var $56173b32960dbab3$var$run = function(id) {
    if ($c51418e3dd02e981$exports($56173b32960dbab3$var$queue, id)) {
        var fn = $56173b32960dbab3$var$queue[id];
        delete $56173b32960dbab3$var$queue[id];
        fn();
    }
};
var $56173b32960dbab3$var$runner = function(id) {
    return function() {
        $56173b32960dbab3$var$run(id);
    };
};
var $56173b32960dbab3$var$eventListener = function(event) {
    $56173b32960dbab3$var$run(event.data);
};
var $56173b32960dbab3$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $c6205de543480f1d$exports.postMessage($56173b32960dbab3$var$String(id), $56173b32960dbab3$var$$location.protocol + "//" + $56173b32960dbab3$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$56173b32960dbab3$var$set || !$56173b32960dbab3$var$clear) {
    $56173b32960dbab3$var$set = function setImmediate(handler) {
        $7cf165f1a18eedff$exports(arguments.length, 1);
        var fn = $6e74dcd3287ee980$exports(handler) ? handler : $56173b32960dbab3$var$Function(handler);
        var args = $1b52762827a188f4$exports(arguments, 1);
        $56173b32960dbab3$var$queue[++$56173b32960dbab3$var$counter] = function() {
            $6c5bdeeed6ccae75$exports(fn, undefined, args);
        };
        $56173b32960dbab3$var$defer($56173b32960dbab3$var$counter);
        return $56173b32960dbab3$var$counter;
    };
    $56173b32960dbab3$var$clear = function clearImmediate(id) {
        delete $56173b32960dbab3$var$queue[id];
    };
    // Node.js 0.8-
    if ($def3e28ccc92020a$exports) $56173b32960dbab3$var$defer = function(id) {
        $56173b32960dbab3$var$process.nextTick($56173b32960dbab3$var$runner(id));
    };
    else if ($56173b32960dbab3$var$Dispatch && $56173b32960dbab3$var$Dispatch.now) $56173b32960dbab3$var$defer = function(id) {
        $56173b32960dbab3$var$Dispatch.now($56173b32960dbab3$var$runner(id));
    };
    else if ($56173b32960dbab3$var$MessageChannel && !$79dce65a5d9fb51a$exports) {
        $56173b32960dbab3$var$channel = new $56173b32960dbab3$var$MessageChannel();
        $56173b32960dbab3$var$port = $56173b32960dbab3$var$channel.port2;
        $56173b32960dbab3$var$channel.port1.onmessage = $56173b32960dbab3$var$eventListener;
        $56173b32960dbab3$var$defer = $817a439101a0a4a9$exports($56173b32960dbab3$var$port.postMessage, $56173b32960dbab3$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($c6205de543480f1d$exports.addEventListener && $6e74dcd3287ee980$exports($c6205de543480f1d$exports.postMessage) && !$c6205de543480f1d$exports.importScripts && $56173b32960dbab3$var$$location && $56173b32960dbab3$var$$location.protocol !== "file:" && !$e8a4bac282106998$exports($56173b32960dbab3$var$globalPostMessageDefer)) {
        $56173b32960dbab3$var$defer = $56173b32960dbab3$var$globalPostMessageDefer;
        $c6205de543480f1d$exports.addEventListener("message", $56173b32960dbab3$var$eventListener, false);
    // IE8-
    } else if ($56173b32960dbab3$var$ONREADYSTATECHANGE in $b6e37854b5d2098b$exports("script")) $56173b32960dbab3$var$defer = function(id) {
        $8bdfb5d01b9c29df$exports.appendChild($b6e37854b5d2098b$exports("script"))[$56173b32960dbab3$var$ONREADYSTATECHANGE] = function() {
            $8bdfb5d01b9c29df$exports.removeChild(this);
            $56173b32960dbab3$var$run(id);
        };
    };
    else $56173b32960dbab3$var$defer = function(id) {
        setTimeout($56173b32960dbab3$var$runner(id), 0);
    };
}
$56173b32960dbab3$exports = {
    set: $56173b32960dbab3$var$set,
    clear: $56173b32960dbab3$var$clear
};


var $028a9258a5bc5e5d$require$clearImmediate = $56173b32960dbab3$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$f6270ddd51c61def$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $c6205de543480f1d$exports.clearImmediate !== $028a9258a5bc5e5d$require$clearImmediate
}, {
    clearImmediate: $028a9258a5bc5e5d$require$clearImmediate
});





var $f7d1c2cba325bc5d$require$setTask = $56173b32960dbab3$exports.set;
var $d4e3cbd99b09bd4c$exports = {};
"use strict";



var $236b72acc084614a$exports = {};
/* global Bun -- Deno case */ $236b72acc084614a$exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";





var $d4e3cbd99b09bd4c$var$Function = $c6205de543480f1d$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $d4e3cbd99b09bd4c$var$WRAP = /MSIE .\./.test($4b763539b040e8c7$exports) || $236b72acc084614a$exports && function() {
    var version = $c6205de543480f1d$exports.Bun.version.split(".");
    return version.length < 3 || version[0] == 0 && (version[1] < 3 || version[1] == 3 && version[2] == 0);
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$d4e3cbd99b09bd4c$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $d4e3cbd99b09bd4c$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $7cf165f1a18eedff$exports(arguments.length, 1) > firstParamIndex;
        var fn = $6e74dcd3287ee980$exports(handler) ? handler : $d4e3cbd99b09bd4c$var$Function(handler);
        var params = boundArgs ? $1b52762827a188f4$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $6c5bdeeed6ccae75$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $f7d1c2cba325bc5d$var$setImmediate = $c6205de543480f1d$exports.setImmediate ? $d4e3cbd99b09bd4c$exports($f7d1c2cba325bc5d$require$setTask, false) : $f7d1c2cba325bc5d$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$f6270ddd51c61def$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $c6205de543480f1d$exports.setImmediate !== $f7d1c2cba325bc5d$var$setImmediate
}, {
    setImmediate: $f7d1c2cba325bc5d$var$setImmediate
});




// ONLY 1 CONTROLLER AND 1 MODEL.  MULTIPLE VIEWS SINCE THEY ARE MUCH BIGGER.
// this file will have all the variables that are reuseable across the project.  If you need to make one change, it propagates throughout.
// the API url is re-used in search data, uploading a recipe to the server, etc.  But what if the url changes, like v3?  That's why it has to be here.
const $ba30e20475feac5a$export$923ea8233b386e99 = "https://forkify-api.herokuapp.com/api/v2/recipes/";
const $ba30e20475feac5a$export$196440f71ed9f601 = 10;
const $ba30e20475feac5a$export$d2f17d20365655cb = 10;
const $ba30e20475feac5a$export$7167c830cefcb6b5 = "220df835-1a45-4239-a9ba-a55de96b4b6b";
const $ba30e20475feac5a$export$3ce8858248d89a69 = 2.5;


// helpers.js has a few functions that are reuseable throughout the project.  Kind of a storinghouse for functions.

// this function will return a new promise which will reject after a certain amount of time
const $bd02c871d9c5ba8e$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const $bd02c871d9c5ba8e$export$2b3ff41fecbef7c8 = async function(url, uploadData) {
    try {
        const fetchPro = uploadData ? fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            // body has to be in JSON, so use JSON.stringify and convert the data.  uploadData is the second parameter
            body: JSON.stringify(uploadData)
        }) : fetch(url);
        const response = await Promise.race([
            fetchPro,
            $bd02c871d9c5ba8e$var$timeout((0, $ba30e20475feac5a$export$196440f71ed9f601))
        ]);
        const data = await response.json();
        if (!response.ok) throw new Error(`${data.message} (${res.status})`);
        return data;
    } catch (err) {
        throw err;
    }
};


const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    recipe: {},
    search: {
        query: "",
        results: [],
        page: 1,
        resultsPerPage: (0, $ba30e20475feac5a$export$d2f17d20365655cb)
    },
    bookmarks: []
};
const $0f1d4402dffacf5b$var$createRecipeObject = function(data) {
    const { recipe: recipe } = data.data;
    return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        // there might not always be a key in recipes, so use the && operator (to short-circuit.  If it doesn't exist, nothing happens) with the spread operator.  What's happening here is if there is a key, then return the key object that returns.  So the entire expression becomes that object, and then spread to put the values here.  Basically, this is a way to conditionally add properties to an object
        ...recipe.key && {
            key: recipe.key
        }
    };
};
const $0f1d4402dffacf5b$export$b96725c7a035d60b = async function(id) {
    try {
        const data = await (0, $bd02c871d9c5ba8e$export$2b3ff41fecbef7c8)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}${id}?key=${(0, $ba30e20475feac5a$export$7167c830cefcb6b5)}`);
        /* let { recipe } = data.data;
    state.recipe = {
      id: recipe.id,
      title: recipe.title,
      publisher: recipe.publisher,
      sourceUrl: recipe.source_url,
      image: recipe.image_url,
      servings: recipe.servings,
      cookingTime: recipe.cooking_time,
      ingredients: recipe.ingredients,
    };
    */ $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe = $0f1d4402dffacf5b$var$createRecipeObject(data);
        // if ANY bookmark has a matching id, we want the current recipe to be bookmarked
        if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.some((bookmark)=>bookmark.id === id)) $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = true;
        else $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = false;
        console.log($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        // the error occurs in the getJSON function, and not in here.  How is it done?  with "throw".  But this really should be in the view, so move that logic over to recipeView.
        console.error(`${err} 💥💥💥💥`);
        throw err;
    }
};
const $0f1d4402dffacf5b$export$202b8e5cb363a0c4 = async function(query) {
    try {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.query = query;
        const data = await (0, $bd02c871d9c5ba8e$export$2b3ff41fecbef7c8)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}?search=${query}&key=${(0, $ba30e20475feac5a$export$7167c830cefcb6b5)}`);
        console.log(data);
        // create a new array, loop over it
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results = data.data.recipes.map((recipe)=>{
            return {
                id: recipe.id,
                title: recipe.title,
                publisher: recipe.publisher,
                image: recipe.image_url,
                ...recipe.key && {
                    key: recipe.key
                }
            }; // store this in state
        });
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.page = 1;
    } catch (err) {
        console.error(`${err} 💥💥💥💥`);
        throw err;
    }
};
const $0f1d4402dffacf5b$export$8d7f79465139ab72 = function(page = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.page) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.page = page;
    // slice will return part of it, so from result 1 to 10
    const start = (page - 1) * $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.resultsPerPage; // if we returned 9 pages, then 9 - 1 = 8.  8 * 10 = 80
    const end = page * $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.resultsPerPage; // if we returned 9 pages, then 9 * 10 = 90
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results.slice(start, end);
};
const $0f1d4402dffacf5b$export$5e23f4642ecad5ea = function(newServings) {
    // this goes into the recipe ingredients and changes the quantity of ingredients
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.ingredients.forEach((ingredient)=>{
        ingredient.quantity = ingredient.quantity * newServings / $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.servings;
    });
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.servings = newServings;
};
// no need to export since it will be called in addBookmark and deleteBookmark
const $0f1d4402dffacf5b$var$persistBookmarks = function() {
    // set a string by calling JSON.stringify and convert state.bookmarks to a string
    localStorage.setItem("bookmarks", JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks));
};
const $0f1d4402dffacf5b$export$72009cc673d27d80 = function(recipe) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.push(recipe);
    // mark the current recipe as bookmarked
    if (recipe.id === $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.id) $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = true;
    $0f1d4402dffacf5b$var$persistBookmarks();
};
const $0f1d4402dffacf5b$export$136048bcb9946c75 = function(id) {
    // calculate index with findIndex.  We're looking for the element with the id that equals the id that was passed in (only 1 can exist).  Then take the index and delete from the array
    const index = $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.findIndex((el)=>el.id === id);
    // splice will delete the id.  Index of the location of the element, deleting only 1
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.splice(index, 1);
    // current recipe is no longer a bookmark
    if (id === $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.id) $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = false;
    $0f1d4402dffacf5b$var$persistBookmarks();
};
const $0f1d4402dffacf5b$var$init = function() {
    // call init to get the bookmarks that are persisted in localStorage
    const storage = localStorage.getItem("bookmarks");
    // JSON.parse will convert STRING back to OBJECT.
    if (storage) $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks = JSON.parse(storage);
};
$0f1d4402dffacf5b$var$init();
const $0f1d4402dffacf5b$export$d660c2254e74960d = async function(newRecipe) {
    try {
        // get the raw input data and transform it into the same format as the data we get out of the API.
        // create an array of ingredients, so use the map methods to create new arrays.  We need an array, so convert the object we get back into an array.  This is the opposite of Object.fromEntries
        const ingredients = Object.entries(newRecipe)// filter with the entry.  We only want the entries where the first element of the array starts with "ingredient".  The second part cannot be empty.  In the entry, the 1st element of the current entry should start with ingredient and the 2nd one should exist.
        /* 
    it will say something like ingredient-1, 0.5,kg,rice
    */ .filter((entry)=>entry[0].startsWith("ingredient") && entry[1] !== "")// use map to put into an object. so take the ingredients and split by a comma, removing any whitespace
        .map((ingredient)=>{
            // split the string into multiple parts that returns an array.  Then loop over the array and trim the elements
            const ingredientsArray = ingredient[1].split(", ").map((el)=>el.trim());
            // does ingredientsArray have a length of 3?  If not, throw an error
            if (ingredientsArray.length !== 3) throw new Error("Wrong ingredient format.");
            //de-struct the array
            const [quantity, unit, description] = ingredientsArray;
            return {
                // quantity: 1, unit: "", description: "chopped sweet onion"
                // convert null to a number with +quantity.  If there is a quantity, convert to a number with the ternaray operator.  If there is an empty string, return null
                quantity: quantity ? +quantity : null,
                unit: unit,
                description: description
            };
        });
        const recipe = {
            title: newRecipe.title,
            source_url: newRecipe.sourceUrl,
            image_url: newRecipe.image,
            publisher: newRecipe.publisher,
            // force these to be converted to numbers with +
            cooking_time: +newRecipe.cookingTime,
            servings: +newRecipe.servings,
            ingredients: ingredients
        };
        const data = await (0, $bd02c871d9c5ba8e$export$2b3ff41fecbef7c8)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}?key=${(0, $ba30e20475feac5a$export$7167c830cefcb6b5)}`, recipe);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe = $0f1d4402dffacf5b$var$createRecipeObject(data);
        $0f1d4402dffacf5b$export$72009cc673d27d80($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        throw err;
    }
}; // some ideas to put into this web app:  1) display the number of total recipes found, 2) do the ingredient validation before submitting the form, 3) IMPROVE the recipe input (change the way users can add their ingredients), 4) weekly meal-planning feature (assign recipes for the week and show them on a weekly calendar), 5) get nutrition data?



var $d981731ada74638f$exports = {};

$d981731ada74638f$exports = new URL((parcelRequire("27Lyk")).resolve("eyyUD"), import.meta.url).toString();


class $3a07c34e115c11c9$export$2e2bcd8739ae039 {
    _data;
    // this receives data and will set this._data to the data it received.  We didn't put the const markup in render because the idea will be to use render on other views and classes.
    // this is part of the public API.
    // how to use jsdocs.  Goto jsdoc.app for more info
    // to write documentation, write a multi-line comment and then a second star.  "data" and "render" are our parameters
    /**
   * Render the received object to the DOM
   *
   * @param {Object | Object[]} data Data is the name of the parameter is this represents the data to be rendered (i.e. a recipe)
   * @param {boolean} [render=true] If this is false, then create markup string instead of rendering to the DOM.  What's the advantage?  If you work with someone else, then that programmer should understand what you did.
   * @returns {undefined | string} What does this render function return?  Either nothing or a string
   * @this {Object} Here, the "this" keyword points to the View object itself
   * @author Jonas Schmedtmann
   * @todo Finish implementation
   */ render(data, render = true) {
        // there is a helper function on the Array constructor which checks if it is an array and the length is 0.  Exit the function right away and render the error
        if (!data || Array.isArray(data) && data.length === 0) return this.renderError();
        this._data = data;
        // now, render the data by putting into the view.  Don't put it in render since render will be common to all of the classes.
        const markup = this._generateMarkup();
        // return the generated markup if false.  Why not call generateMarkup itself?  Because we need it to set the data property to the data we passed in.
        if (!render) return markup;
        this._clear();
        // render the HTML, and put it after the start.
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    update(data) {
        this._data = data;
        const newMarkup = this._generateMarkup();
        const newDOM = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDOM.querySelectorAll("*"));
        const currentElements = Array.from(this._parentElement.querySelectorAll("*"));
        newElements.forEach((newEl, i)=>{
            const currentElement = currentElements[i];
            if (!newEl.isEqualNode(currentElement) && // ? is there in case firstChild element doesn't exist
            newEl.firstChild?.nodeValue.trim() !== "") currentElement.textContent = newEl.textContent;
            // update the changed attributes
            if (!newEl.isEqualNode(currentElement)) Array.from(newEl.attributes).forEach((attribute)=>currentElement.setAttribute(attribute.name, attribute.value));
        });
    }
    // abstract _clear to make it a little cleaner.  More importantly, it becomes reuseable!
    _clear() {
        this._parentElement.innerHTML = "";
    }
    // not business logic, so it belongs here in the view.  This is a PUBLIC method.
    renderSpinner() {
        const markup = `
    <div class="spinner">
    <svg>
      <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports)))}#icon-loader"></use>
    </svg>
  </div>
    `;
        // this function returns an HTML string, and render is responsible for putting the HTML on the page.
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderError(message = this._errorMessage) {
        const markup = `
    <div class="error">
          <div>
            <svg>
              <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports)))}#icon-alert-triangle"></use>
            </svg>
          </div>
          <p>${message}</p>
        </div>
    `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderMessage(message = this._message) {
        const markup = `
    <div class="message">
          <div>
            <svg>
              <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports)))}#icon-smile"></use>
            </svg>
          </div>
          <p>${message}</p>
        </div>
    `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
} /*  
 // this is a private method.  Call it with const markup.  Where is recipe.data (like, image, title, cookingTime, etc)?  In this._data.  The recipe is loaded in controller.js and stored in the state object.  Then, take model.state.recipe and pass it into the render method.  Then, render takes the data and stores it in this._data.  Then, we can use it anywhere.
  _generateMarkup() {
    return `
    <figure class="recipe__fig">
    <img src="${this._data.image}" alt="${
      this._data.title
    }" class="recipe__img" />
    <h1 class="recipe__title">
      <span>${this._data.title}</span>
    </h1>
  </figure>

  <div class="recipe__details">
    <div class="recipe__info">
      <svg class="recipe__info-icon">
        <use href="${icons}#icon-clock"></use>
      </svg>
      <span class="recipe__info-data recipe__info-data--minutes">${
        this._data.cookingTime
      }</span>
      <span class="recipe__info-text">minutes</span>
    </div>
    <div class="recipe__info">
      <svg class="recipe__info-icon">
        <use href="${icons}#icon-users"></use>
      </svg>
      <span class="recipe__info-data recipe__info-data--people">${
        this._data.servings
      }</span>
      <span class="recipe__info-text">servings</span>

      <div class="recipe__info-buttons">
        <button class="btn--tiny btn--increase-servings">
          <svg>
            <use href="${icons}#icon-minus-circle"></use>
          </svg>
        </button>
        <button class="btn--tiny btn--increase-servings">
          <svg>
            <use href="${icons}#icon-plus-circle"></use>
          </svg>
        </button>
      </div>
    </div>

    <div class="recipe__user-generated">
      <svg>
        <use href="${icons}#icon-user"></use>
      </svg>
    </div>
    <button class="btn--round">
      <svg class="">
        <use href="${icons}#icon-bookmark-fill"></use>
      </svg>
    </button>
  </div>

  <div class="recipe__ingredients">
    <h2 class="heading--2">Recipe ingredients</h2>
    <ul class="recipe__ingredient-list">
    ${this._data.ingredients.map(this._generateMarkupIngredient).join('')}
      <li class="recipe__ingredient">
        <svg class="recipe__icon">
          <use href="${icons}#icon-check"></use>
        </svg>
        <div class="recipe__quantity">1000</div>
        <div class="recipe__description">
          <span class="recipe__unit">g</span>
          pasta
        </div>
      </li>
    </ul>
  </div>

  <div class="recipe__directions">
    <h2 class="heading--2">How to cook it</h2>
    <p class="recipe__directions-text">
      This recipe was carefully designed and tested by
      <span class="recipe__publisher">${
        this._data.publisher
      }</span>. Please check out
      directions at their website.
    </p>
    <a
      class="btn--small recipe__btn"
      href="${this._data.sourceUrl}"
      target="_blank"
    >
      <span>Directions</span>
      <svg class="search__icon">
        <use href="${icons}#icon-arrow-right"></use>
      </svg>
    </a>
  </div>
    `;
  }
*/ 



var $6e19961aa732cf94$exports = {};
/**
 * @license Fraction.js v4.2.0 05/03/2022
 * https://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2021, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/ /**
 *
 * This class offers the possibility to calculate fractions.
 * You can pass a fraction in different formats. Either as array, as double, as string or as an integer.
 *
 * Array/Object form
 * [ 0 => <nominator>, 1 => <denominator> ]
 * [ n => <nominator>, d => <denominator> ]
 *
 * Integer form
 * - Single integer value
 *
 * Double form
 * - Single double value
 *
 * String form
 * 123.456 - a simple double
 * 123/456 - a string fraction
 * 123.'456' - a double with repeating decimal places
 * 123.(456) - synonym
 * 123.45'6' - a double with repeating last place
 * 123.45(6) - synonym
 *
 * Example:
 *
 * var f = new Fraction("9.4'31'");
 * f.mul([-4, 3]).div(4.9);
 *
 */ (function(root) {
    "use strict";
    // Maximum search depth for cyclic rational numbers. 2000 should be more than enough.
    // Example: 1/7 = 0.(142857) has 6 repeating decimal places.
    // If MAX_CYCLE_LEN gets reduced, long cycles will not be detected and toString() only gets the first 10 digits
    var MAX_CYCLE_LEN = 2000;
    // Parsed data to avoid calling "new" all the time
    var P = {
        "s": 1,
        "n": 0,
        "d": 1
    };
    function assign(n, s) {
        if (isNaN(n = parseInt(n, 10))) throw Fraction["InvalidParameter"];
        return n * s;
    }
    // Creates a new Fraction internally without the need of the bulky constructor
    function newFraction(n, d) {
        if (d === 0) throw Fraction["DivisionByZero"];
        var f = Object.create(Fraction.prototype);
        f["s"] = n < 0 ? -1 : 1;
        n = n < 0 ? -n : n;
        var a = gcd(n, d);
        f["n"] = n / a;
        f["d"] = d / a;
        return f;
    }
    function factorize(num) {
        var factors = {};
        var n = num;
        var i = 2;
        var s = 4;
        while(s <= n){
            while(n % i === 0){
                n /= i;
                factors[i] = (factors[i] || 0) + 1;
            }
            s += 1 + 2 * i++;
        }
        if (n !== num) {
            if (n > 1) factors[n] = (factors[n] || 0) + 1;
        } else factors[num] = (factors[num] || 0) + 1;
        return factors;
    }
    var parse = function(p1, p2) {
        var n = 0, d = 1, s = 1;
        var v = 0, w = 0, x = 0, y = 1, z = 1;
        var A = 0, B = 1;
        var C = 1, D = 1;
        var N = 10000000;
        var M;
        if (p1 === undefined || p1 === null) ;
        else if (p2 !== undefined) {
            n = p1;
            d = p2;
            s = n * d;
            if (n % 1 !== 0 || d % 1 !== 0) throw Fraction["NonIntegerParameter"];
        } else switch(typeof p1){
            case "object":
                if ("d" in p1 && "n" in p1) {
                    n = p1["n"];
                    d = p1["d"];
                    if ("s" in p1) n *= p1["s"];
                } else if (0 in p1) {
                    n = p1[0];
                    if (1 in p1) d = p1[1];
                } else throw Fraction["InvalidParameter"];
                s = n * d;
                break;
            case "number":
                if (p1 < 0) {
                    s = p1;
                    p1 = -p1;
                }
                if (p1 % 1 === 0) n = p1;
                else if (p1 > 0) {
                    if (p1 >= 1) {
                        z = Math.pow(10, Math.floor(1 + Math.log(p1) / Math.LN10));
                        p1 /= z;
                    }
                    // Using Farey Sequences
                    // http://www.johndcook.com/blog/2010/10/20/best-rational-approximation/
                    while(B <= N && D <= N){
                        M = (A + C) / (B + D);
                        if (p1 === M) {
                            if (B + D <= N) {
                                n = A + C;
                                d = B + D;
                            } else if (D > B) {
                                n = C;
                                d = D;
                            } else {
                                n = A;
                                d = B;
                            }
                            break;
                        } else {
                            if (p1 > M) {
                                A += C;
                                B += D;
                            } else {
                                C += A;
                                D += B;
                            }
                            if (B > N) {
                                n = C;
                                d = D;
                            } else {
                                n = A;
                                d = B;
                            }
                        }
                    }
                    n *= z;
                } else if (isNaN(p1) || isNaN(p2)) d = n = NaN;
                break;
            case "string":
                B = p1.match(/\d+|./g);
                if (B === null) throw Fraction["InvalidParameter"];
                if (B[A] === "-") {
                    s = -1;
                    A++;
                } else if (B[A] === "+") A++;
                if (B.length === A + 1) w = assign(B[A++], s);
                else if (B[A + 1] === "." || B[A] === ".") {
                    if (B[A] !== ".") v = assign(B[A++], s);
                    A++;
                    // Check for decimal places
                    if (A + 1 === B.length || B[A + 1] === "(" && B[A + 3] === ")" || B[A + 1] === "'" && B[A + 3] === "'") {
                        w = assign(B[A], s);
                        y = Math.pow(10, B[A].length);
                        A++;
                    }
                    // Check for repeating places
                    if (B[A] === "(" && B[A + 2] === ")" || B[A] === "'" && B[A + 2] === "'") {
                        x = assign(B[A + 1], s);
                        z = Math.pow(10, B[A + 1].length) - 1;
                        A += 3;
                    }
                } else if (B[A + 1] === "/" || B[A + 1] === ":") {
                    w = assign(B[A], s);
                    y = assign(B[A + 2], 1);
                    A += 3;
                } else if (B[A + 3] === "/" && B[A + 1] === " ") {
                    v = assign(B[A], s);
                    w = assign(B[A + 2], s);
                    y = assign(B[A + 4], 1);
                    A += 5;
                }
                if (B.length <= A) {
                    d = y * z;
                    s = /* void */ n = x + d * v + z * w;
                    break;
                }
            default:
                throw Fraction["InvalidParameter"];
        }
        if (d === 0) throw Fraction["DivisionByZero"];
        P["s"] = s < 0 ? -1 : 1;
        P["n"] = Math.abs(n);
        P["d"] = Math.abs(d);
    };
    function modpow(b, e, m) {
        var r = 1;
        for(; e > 0; b = b * b % m, e >>= 1)if (e & 1) r = r * b % m;
        return r;
    }
    function cycleLen(n, d) {
        for(; d % 2 === 0; d /= 2);
        for(; d % 5 === 0; d /= 5);
        if (d === 1) return 0;
        // If we would like to compute really large numbers quicker, we could make use of Fermat's little theorem:
        // 10^(d-1) % d == 1
        // However, we don't need such large numbers and MAX_CYCLE_LEN should be the capstone,
        // as we want to translate the numbers to strings.
        var rem = 10 % d;
        var t = 1;
        for(; rem !== 1; t++){
            rem = rem * 10 % d;
            if (t > MAX_CYCLE_LEN) return 0; // Returning 0 here means that we don't print it as a cyclic number. It's likely that the answer is `d-1`
        }
        return t;
    }
    function cycleStart(n, d, len) {
        var rem1 = 1;
        var rem2 = modpow(10, len, d);
        for(var t = 0; t < 300; t++){
            // Solve 10^s == 10^(s+t) (mod d)
            if (rem1 === rem2) return t;
            rem1 = rem1 * 10 % d;
            rem2 = rem2 * 10 % d;
        }
        return 0;
    }
    function gcd(a, b) {
        if (!a) return b;
        if (!b) return a;
        while(true){
            a %= b;
            if (!a) return b;
            b %= a;
            if (!b) return a;
        }
    }
    /**
   * Module constructor
   *
   * @constructor
   * @param {number|Fraction=} a
   * @param {number=} b
   */ function Fraction(a, b) {
        parse(a, b);
        if (this instanceof Fraction) {
            a = gcd(P["d"], P["n"]); // Abuse variable a
            this["s"] = P["s"];
            this["n"] = P["n"] / a;
            this["d"] = P["d"] / a;
        } else return newFraction(P["s"] * P["n"], P["d"]);
    }
    Fraction["DivisionByZero"] = new Error("Division by Zero");
    Fraction["InvalidParameter"] = new Error("Invalid argument");
    Fraction["NonIntegerParameter"] = new Error("Parameters must be integer");
    Fraction.prototype = {
        "s": 1,
        "n": 0,
        "d": 1,
        /**
     * Calculates the absolute value
     *
     * Ex: new Fraction(-4).abs() => 4
     **/ "abs": function() {
            return newFraction(this["n"], this["d"]);
        },
        /**
     * Inverts the sign of the current fraction
     *
     * Ex: new Fraction(-4).neg() => 4
     **/ "neg": function() {
            return newFraction(-this["s"] * this["n"], this["d"]);
        },
        /**
     * Adds two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
     **/ "add": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * this["n"] * P["d"] + P["s"] * this["d"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Subtracts two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
     **/ "sub": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * this["n"] * P["d"] - P["s"] * this["d"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Multiplies two rational numbers
     *
     * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
     **/ "mul": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * P["s"] * this["n"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Divides two rational numbers
     *
     * Ex: new Fraction("-17.(345)").inverse().div(3)
     **/ "div": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * P["s"] * this["n"] * P["d"], this["d"] * P["n"]);
        },
        /**
     * Clones the actual object
     *
     * Ex: new Fraction("-17.(345)").clone()
     **/ "clone": function() {
            return newFraction(this["s"] * this["n"], this["d"]);
        },
        /**
     * Calculates the modulo of two rational numbers - a more precise fmod
     *
     * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
     **/ "mod": function(a, b) {
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            if (a === undefined) return newFraction(this["s"] * this["n"] % this["d"], 1);
            parse(a, b);
            if (0 === P["n"] && 0 === this["d"]) throw Fraction["DivisionByZero"];
            /*
       * First silly attempt, kinda slow
       *
       return that["sub"]({
       "n": num["n"] * Math.floor((this.n / this.d) / (num.n / num.d)),
       "d": num["d"],
       "s": this["s"]
       });*/ /*
       * New attempt: a1 / b1 = a2 / b2 * q + r
       * => b2 * a1 = a2 * b1 * q + b1 * b2 * r
       * => (b2 * a1 % a2 * b1) / (b1 * b2)
       */ return newFraction(this["s"] * (P["d"] * this["n"]) % (P["n"] * this["d"]), P["d"] * this["d"]);
        },
        /**
     * Calculates the fractional gcd of two rational numbers
     *
     * Ex: new Fraction(5,8).gcd(3,7) => 1/56
     */ "gcd": function(a, b) {
            parse(a, b);
            // gcd(a / b, c / d) = gcd(a, c) / lcm(b, d)
            return newFraction(gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]), P["d"] * this["d"]);
        },
        /**
     * Calculates the fractional lcm of two rational numbers
     *
     * Ex: new Fraction(5,8).lcm(3,7) => 15
     */ "lcm": function(a, b) {
            parse(a, b);
            // lcm(a / b, c / d) = lcm(a, c) / gcd(b, d)
            if (P["n"] === 0 && this["n"] === 0) return newFraction(0, 1);
            return newFraction(P["n"] * this["n"], gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]));
        },
        /**
     * Calculates the ceil of a rational number
     *
     * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
     **/ "ceil": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.ceil(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Calculates the floor of a rational number
     *
     * Ex: new Fraction('4.(3)').floor() => (4 / 1)
     **/ "floor": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.floor(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Rounds a rational numbers
     *
     * Ex: new Fraction('4.(3)').round() => (4 / 1)
     **/ "round": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.round(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Gets the inverse of the fraction, means numerator and denominator are exchanged
     *
     * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
     **/ "inverse": function() {
            return newFraction(this["s"] * this["d"], this["n"]);
        },
        /**
     * Calculates the fraction to some rational exponent, if possible
     *
     * Ex: new Fraction(-1,2).pow(-3) => -8
     */ "pow": function(a, b) {
            parse(a, b);
            // Trivial case when exp is an integer
            if (P["d"] === 1) {
                if (P["s"] < 0) return newFraction(Math.pow(this["s"] * this["d"], P["n"]), Math.pow(this["n"], P["n"]));
                else return newFraction(Math.pow(this["s"] * this["n"], P["n"]), Math.pow(this["d"], P["n"]));
            }
            // Negative roots become complex
            //     (-a/b)^(c/d) = x
            // <=> (-1)^(c/d) * (a/b)^(c/d) = x
            // <=> (cos(pi) + i*sin(pi))^(c/d) * (a/b)^(c/d) = x         # rotate 1 by 180°
            // <=> (cos(c*pi/d) + i*sin(c*pi/d)) * (a/b)^(c/d) = x       # DeMoivre's formula in Q ( https://proofwiki.org/wiki/De_Moivre%27s_Formula/Rational_Index )
            // From which follows that only for c=0 the root is non-complex. c/d is a reduced fraction, so that sin(c/dpi)=0 occurs for d=1, which is handled by our trivial case.
            if (this["s"] < 0) return null;
            // Now prime factor n and d
            var N = factorize(this["n"]);
            var D = factorize(this["d"]);
            // Exponentiate and take root for n and d individually
            var n = 1;
            var d = 1;
            for(var k in N){
                if (k === "1") continue;
                if (k === "0") {
                    n = 0;
                    break;
                }
                N[k] *= P["n"];
                if (N[k] % P["d"] === 0) N[k] /= P["d"];
                else return null;
                n *= Math.pow(k, N[k]);
            }
            for(var k in D){
                if (k === "1") continue;
                D[k] *= P["n"];
                if (D[k] % P["d"] === 0) D[k] /= P["d"];
                else return null;
                d *= Math.pow(k, D[k]);
            }
            if (P["s"] < 0) return newFraction(d, n);
            return newFraction(n, d);
        },
        /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/ "equals": function(a, b) {
            parse(a, b);
            return this["s"] * this["n"] * P["d"] === P["s"] * P["n"] * this["d"]; // Same as compare() === 0
        },
        /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/ "compare": function(a, b) {
            parse(a, b);
            var t = this["s"] * this["n"] * P["d"] - P["s"] * P["n"] * this["d"];
            return (0 < t) - (t < 0);
        },
        "simplify": function(eps) {
            if (isNaN(this["n"]) || isNaN(this["d"])) return this;
            eps = eps || 0.001;
            var thisABS = this["abs"]();
            var cont = thisABS["toContinued"]();
            for(var i = 1; i < cont.length; i++){
                var s = newFraction(cont[i - 1], 1);
                for(var k = i - 2; k >= 0; k--)s = s["inverse"]()["add"](cont[k]);
                if (s["sub"](thisABS)["abs"]().valueOf() < eps) return s["mul"](this["s"]);
            }
            return this;
        },
        /**
     * Check if two rational numbers are divisible
     *
     * Ex: new Fraction(19.6).divisible(1.5);
     */ "divisible": function(a, b) {
            parse(a, b);
            return !(!(P["n"] * this["d"]) || this["n"] * P["d"] % (P["n"] * this["d"]));
        },
        /**
     * Returns a decimal representation of the fraction
     *
     * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
     **/ "valueOf": function() {
            return this["s"] * this["n"] / this["d"];
        },
        /**
     * Returns a string-fraction representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toFraction(true) => "4 1/3"
     **/ "toFraction": function(excludeWhole) {
            var whole, str = "";
            var n = this["n"];
            var d = this["d"];
            if (this["s"] < 0) str += "-";
            if (d === 1) str += n;
            else {
                if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
                    str += whole;
                    str += " ";
                    n %= d;
                }
                str += n;
                str += "/";
                str += d;
            }
            return str;
        },
        /**
     * Returns a latex representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
     **/ "toLatex": function(excludeWhole) {
            var whole, str = "";
            var n = this["n"];
            var d = this["d"];
            if (this["s"] < 0) str += "-";
            if (d === 1) str += n;
            else {
                if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
                    str += whole;
                    n %= d;
                }
                str += "\\frac{";
                str += n;
                str += "}{";
                str += d;
                str += "}";
            }
            return str;
        },
        /**
     * Returns an array of continued fraction elements
     *
     * Ex: new Fraction("7/8").toContinued() => [0,1,7]
     */ "toContinued": function() {
            var t;
            var a = this["n"];
            var b = this["d"];
            var res = [];
            if (isNaN(a) || isNaN(b)) return res;
            do {
                res.push(Math.floor(a / b));
                t = a % b;
                a = b;
                b = t;
            }while (a !== 1);
            return res;
        },
        /**
     * Creates a string representation of a fraction with all digits
     *
     * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
     **/ "toString": function(dec) {
            var N = this["n"];
            var D = this["d"];
            if (isNaN(N) || isNaN(D)) return "NaN";
            dec = dec || 15; // 15 = decimal places when no repetation
            var cycLen = cycleLen(N, D); // Cycle length
            var cycOff = cycleStart(N, D, cycLen); // Cycle start
            var str = this["s"] < 0 ? "-" : "";
            str += N / D | 0;
            N %= D;
            N *= 10;
            if (N) str += ".";
            if (cycLen) {
                for(var i = cycOff; i--;){
                    str += N / D | 0;
                    N %= D;
                    N *= 10;
                }
                str += "(";
                for(var i = cycLen; i--;){
                    str += N / D | 0;
                    N %= D;
                    N *= 10;
                }
                str += ")";
            } else for(var i = dec; N && i--;){
                str += N / D | 0;
                N %= D;
                N *= 10;
            }
            return str;
        }
    };
    if (typeof define === "function" && define["amd"]) define([], function() {
        return Fraction;
    });
    else {
        Object.defineProperty(Fraction, "__esModule", {
            "value": true
        });
        Fraction["default"] = Fraction;
        Fraction["Fraction"] = Fraction;
        $6e19961aa732cf94$exports = Fraction;
    }
})($6e19961aa732cf94$exports);


var $7238a34a955809b2$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7238a34a955809b2$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $7238a34a955809b2$exports));
try {
    regeneratorRuntime = $7238a34a955809b2$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7238a34a955809b2$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7238a34a955809b2$var$runtime);
}


// this view is a class since there will be a "View" parent class that will contain methods that all views have to inherit.  Using classes makes it easy to implement. Also, classes makes it easy to implement private methods and properties, so classes make it easy to do.
class $d14dc0f178617192$var$RecipeView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    // private methods
    // #parentElement is private, and it's set to the recipe container.  It makes it easy to render the spinner, success/error messages, and (of course) the recipe itself!
    _parentElement = document.querySelector(".recipe");
    _errorMessage = "No recipes found.";
    _message = "";
    // publisher/subscriber pattern.  addHandlerRender is the publisher listening for the event.  It receives the handler function (a controller that lives in the controller).  Then, we can listen for it in the view while handle it in the controller.  It will reside in paginationView.js
    addHandlerRender(handler) {
        // eventListener is the event, and controlRecipes is the handler function.  In the first iteration, it's 'hashchange'.  In the second, it is 'load'.  It's the same as doing this:
        /*  
window.addEventListener('hashchange', controlRecipes);
window.addEventListener('load', controlRecipes);
*/ [
            "hashchange",
            "load"
        ].forEach((eventListener)=>window.addEventListener(eventListener, handler));
    }
    addHandlerUpdateServings(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--update-servings");
            if (!btn) return;
            const { updateTo: updateTo } = btn.dataset;
            // convert it to a number with +
            if (+updateTo > 0) handler(+updateTo);
        });
    }
    addHandlerAddBookmark(handler) {
        this._parentElement.addEventListener("click", function(e) {
            // just in case the user clicks on the icon element instead of the button.
            const btn = e.target.closest(".btn--bookmark");
            // a guard clause
            if (!btn) return;
            handler();
        });
    }
    _generateMarkup() {
        return `
      <figure class="recipe__fig">
        <img src="${this._data.image}" alt="${this._data.title}" class="recipe__img" />
        <h1 class="recipe__title">
          <span>${this._data.title}</span>
        </h1>
      </figure>

      <div class="recipe__details">
        <div class="recipe__info">
          <svg class="recipe__info-icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports))}#icon-clock"></use>
          </svg>
          <span class="recipe__info-data recipe__info-data--minutes">${this._data.cookingTime}</span>
          <span class="recipe__info-text">minutes</span>
        </div>
        <div class="recipe__info">
          <svg class="recipe__info-icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports))}#icon-users"></use>
          </svg>
          <span class="recipe__info-data recipe__info-data--people">${this._data.servings}</span>
          <span class="recipe__info-text">servings</span>

          <div class="recipe__info-buttons">
            <button class="btn--tiny btn--update-servings" data-update-to="${this._data.servings - 1}">
              <svg>
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports))}#icon-minus-circle"></use>
              </svg>
            </button>
            <button class="btn--tiny btn--update-servings" data-update-to="${this._data.servings + 1}">
              <svg>
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports))}#icon-plus-circle"></use>
              </svg>
            </button>
          </div>
        </div>

        <div class="recipe__user-generated ${this._data.key ? "" : "hidden"}">
          <svg>
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports))}#icon-user"></use>
          </svg>
        </div>
        <button class="btn--round btn--bookmark">
          <svg class="">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports))}#icon-bookmark${this._data.bookmarked ? "-fill" : ""}"></use>
          </svg>
        </button>
      </div>

      <div class="recipe__ingredients">
        <h2 class="heading--2">Recipe ingredients</h2>
        <ul class="recipe__ingredient-list">
          ${this._data.ingredients.map(this._generateMarkupIngredient).join("")}
      </div>

      <div class="recipe__directions">
        <h2 class="heading--2">How to cook it</h2>
        <p class="recipe__directions-text">
          This recipe was carefully designed and tested by
          <span class="recipe__publisher">${this._data.publisher}</span>. Please check out
          directions at their website.
        </p>
        <a
          class="btn--small recipe__btn"
          href="${this._data.sourceUrl}"
          target="_blank"
        >
          <span>Directions</span>
          <svg class="search__icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports))}#icon-arrow-right"></use>
          </svg>
        </a>
      </div>
    `;
    }
    // this will receive the ingredient
    _generateMarkupIngredient(ingredient) {
        return `
      <li class="recipe__ingredient">
      <svg class="recipe__icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports))}#icon-check"></use>
      </svg>
      <div class="recipe__quantity">${ingredient.quantity ? new (0, $6e19961aa732cf94$exports.Fraction)(ingredient.quantity).toString() : ""}</div>
      <div class="recipe__description">
        <span class="recipe__unit">${ingredient.unit}</span>
        ${ingredient.description}
      </div>
    </li>
      `;
    }
}
var // needs to be exported so the controller can use it.  It's too much work on the controller to export the ENTIRE class, then in the controller, we'd have to import it AND create a new object out of it (create a new RecipeView object.  However, you may be creating more than one view.  It also makes it more difficult on the controller (Keep it simple).  // To avoid it, create the object here and then export it, so no one from the outside of the class can access it except for the object.  Don't pass any data in, so no need for a constructor
$d14dc0f178617192$export$2e2bcd8739ae039 = new $d14dc0f178617192$var$RecipeView();


// create a class that will inherit from View
class $813cf99795e9ec97$var$SearchView {
    _parentElement = document.querySelector(".search");
    getQuery() {
        const query = this._parentElement.querySelector(".search__field").value;
        this._clearInput();
        return query;
    }
    _clearInput() {
        this._parentElement.querySelector(".search__field").value = "";
    }
    addHandlerSearch(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            // this handler function is the controlSearchResults function!
            handler();
        });
    }
}
var // don't export this class, but an instance (object) that was created by this class
$813cf99795e9ec97$export$2e2bcd8739ae039 = new $813cf99795e9ec97$var$SearchView();






// this will only generate markup for a preview element.  It's really a child view of the bookmarksView and resultsView.  So export it to bookmarksView.js
class $a68ceb92eae160df$var$PreviewView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = "";
    _generateMarkup() {
        const id = window.location.hash.slice(1);
        return `
    <li class="preview">
    <a class="preview__link ${this._data.id === id ? "preview__link--active" : ""}" href="#${this._data.id}">
    <figure class="preview__fig">
    <img src="${this._data.image}" alt="${this._data.title}" />
  </figure>
  <div class="preview__data">
    <h4 class="preview__title">${this._data.title}</h4>
    <p class="preview__publisher">${this._data.publisher}</p>
    <div class="preview__user-generated ${this._data.key ? "" : "hidden"}">
      <svg>
      <use href="${0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports))}#icon-user"></use>
      </svg>
    </div>
  </div>
    </a>
    </li>
    `;
    }
}
var $a68ceb92eae160df$export$2e2bcd8739ae039 = new $a68ceb92eae160df$var$PreviewView();


class $dddbd0b30676c4ae$var$ResultsView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".results");
    _errorMessage = "No recipes found.";
    _message = "";
    _generateMarkup() {
        return this._data.map((result)=>(0, $a68ceb92eae160df$export$2e2bcd8739ae039).render(result, false)).join("");
    }
}
var // new instance of this view.  This way, there's only one results view.
$dddbd0b30676c4ae$export$2e2bcd8739ae039 = new $dddbd0b30676c4ae$var$ResultsView();




class $cfa940594ee109f7$var$PaginationView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".pagination");
    // need a generateMarkup method.  This is the method that render calls to generate the markup for the view we are working on
    // publisher/subscriber pattern
    addHandlerClick(handler) {
        // use event delegation.  There are 2 buttons, but we don't want to listen to them individually.  Rather, let's add the event listener to the common parent element (this._parentElement)
        this._parentElement.addEventListener("click", function(e) {
            // which button was clicked based on the event?  closest() searches down in the tree.
            const btn = e.target.closest(".btn--inline");
            if (!btn) return;
            // the + sign will convert a string to a number
            const goToPage = +btn.dataset.goto;
            handler(goToPage);
        });
    }
    _generateMarkup() {
        const currentPage = this._data.page;
        // we need to know how many pages there are, so let's compute them.  It's the number of results divided by the number of results per page (i.e. 60 results, 10 results per page = 6 pages)
        const totalNumberOfPages = Math.ceil(this._data.results.length / this._data.resultsPerPage); // remember that this data is in our controller.js in the 4th step, which is paginationView.render(model.state.search).  we'll need the search object from model.js
        // if we're on page 1 and there are multiple pages
        if (currentPage === 1 && totalNumberOfPages > 1) return `
      <button data-goto="${currentPage + 1}" class="btn--inline pagination__btn--next">
      <span>Page ${currentPage + 1}</span>
      <svg class="search__icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports))}#icon-arrow-right"></use>
      </svg>
    </button>
      `;
        // if we're on the last page
        if (currentPage === totalNumberOfPages && totalNumberOfPages > 1) return `
      <button data-goto="${currentPage - 1}" class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports))}#icon-arrow-left"></use>
            </svg>
            <span>Page ${currentPage - 1}</span>
          </button>
      `;
        // if we're on another page
        if (currentPage < totalNumberOfPages) return `
      <button data-goto="${currentPage - 1}" class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports))}#icon-arrow-left"></use>
            </svg>
            <span>Page ${currentPage - 1}</span>
          </button>
          <button data-goto="${currentPage + 1}" class="btn--inline pagination__btn--next">
          <span>Page ${currentPage + 1}</span>
          <svg class="search__icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($d981731ada74638f$exports))}#icon-arrow-right"></use>
          </svg>
        </button>
      `;
        // if we're on page 1 and there is only 1 page.  There is no need to show a button since there are no other pages.
        return "";
    }
}
var // export the PaginationView object.  It will be imported into our controller.
$cfa940594ee109f7$export$2e2bcd8739ae039 = new $cfa940594ee109f7$var$PaginationView();




class $5d1bb7e064b2cbd1$var$BookmarksView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".bookmarks__list");
    _errorMessage = "No bookmarks yet.";
    _message = "";
    addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    _generateMarkup() {
        return this._data// for each of the bookmarks, we need to render a preview.  But this should return a string so it can be inserted into the DOM.
        .map((bookmark)=>(0, $a68ceb92eae160df$export$2e2bcd8739ae039).render(bookmark, false)).join("");
    }
}
var $5d1bb7e064b2cbd1$export$2e2bcd8739ae039 = new $5d1bb7e064b2cbd1$var$BookmarksView();



class $e5dc5dc5ede8bdf4$var$AddRecipeView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    // upload is the parent element
    _parentElement = document.querySelector(".upload");
    _message = "Recipe was successfully uploaded.";
    _window = document.querySelector(".add-recipe-window");
    _overlay = document.querySelector(".overlay");
    _btnOpen = document.querySelector(".nav__btn--add-recipe");
    _btnClose = document.querySelector(".btn--close-modal");
    // it's a child class, so call super.  _addHandlerShowWindow.  The _ means it is protected.  The controller doesn't interfere.  But we still have to import this object, so put it in controller.js
    constructor(){
        super();
        this._addHandlerShowWindow();
        this._addHandlerHideWindow();
    }
    toggleWindow() {
        this._overlay.classList.toggle("hidden");
        this._window.classList.toggle("hidden");
    }
    _addHandlerShowWindow() {
        // take the overlay and remove hidden class (or toggle between open and closed).  This makes it reusable.  It's not necessary to put this in the controller, so build a constructor method.
        // manually setting to "this" will point to the current object
        this._btnOpen.addEventListener("click", this.toggleWindow.bind(this));
    }
    _addHandlerHideWindow() {
        this._btnClose.addEventListener("click", this.toggleWindow.bind(this));
        this._overlay.addEventListener("click", this.toggleWindow.bind(this));
    }
    addHandlerUpload(handler) {
        // listen for the upload form event on the parent element
        this._parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            // how do we get access to all of the values?  FormData (a browser API).  Into the FormData constructor, pass in an element that is a form (which is the "this" keyword.)  Because we're in a handler function, so "this" will point to this._parentElement (the upload form).  This returns an object that we have to use the spread operator on (spread it into an array).  This array will contain all of the fields with all of the values in there.
            const dataArray = [
                ...new FormData(this)
            ];
            // what's the goal of the data?  We'll want to upload it to the API.  The uploading is an API call which occur in the model.  So we need to put this data into a model.  So create a controller function that'll handle this event.  Call it controlAddRecipe that will receive the new recipe data.
            // this will convert entries into an object.  This will take an array of entries and convert it.
            const data = Object.fromEntries(dataArray);
            // call the handler function
            handler(data);
        });
    }
    _generateMarkup() {}
}
var $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039 = new $e5dc5dc5ede8bdf4$var$AddRecipeView();



const $f50bd1f2915ed0f2$var$controlRecipes = async function() {
    try {
        const id = window.location.hash.slice(1);
        // make a guard clause in case there are no search queries
        if (!id) return;
        // 1) load the recipe
        // this will automatically render the spinner on the recipeView.
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).renderSpinner();
        (0, $dddbd0b30676c4ae$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$8d7f79465139ab72());
        (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
        // async function which returns a promise.  One async function calling another async function.
        // remember that loadRecipe doesn't return anything, so there is no need to store it in a variable.
        // The recipe gets loaded and is then stored in the state object.
        await $0f1d4402dffacf5b$export$b96725c7a035d60b(id);
        // 2) render the recipe
        // pass in the data.  render is a common name for methods in react too.
        // model.state.recipe was received in step 1 and then passed into the render method.  Then, "render" stores it in recipeView.js in render.  And finally, that calls generateMarkup
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).renderError();
        console.error(err);
    }
};
// this will call async loadSearchResults.  This function is responsible for showing the search results
const $f50bd1f2915ed0f2$var$controlSearchResults = async function() {
    try {
        (0, $dddbd0b30676c4ae$export$2e2bcd8739ae039).renderSpinner();
        // 1) get the search query
        const query = (0, $813cf99795e9ec97$export$2e2bcd8739ae039).getQuery();
        if (!query) return;
        // 2) we call loadSearchResults here and load the search results
        await $0f1d4402dffacf5b$export$202b8e5cb363a0c4(query);
        // 3) render the results.  This is coming from model.js, and we need to store the page number from getSearchResultsPage in our model.
        (0, $dddbd0b30676c4ae$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$8d7f79465139ab72());
        // 4) render the initial pagination buttons.  This has to have a render method on it.  Pass in the ENTIRE search object.  Reference paginationView.js for the equation.
        (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search);
    } catch (err) {
        console.log(err);
    }
};
const $f50bd1f2915ed0f2$var$controlPagination = function(goToPage) {
    // render the NEW search results
    (0, $dddbd0b30676c4ae$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$8d7f79465139ab72(goToPage));
    // and render the NEW pagination buttons
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search);
};
// this is also known as an event handler.  It's executed whenever the user changes the serving size.
const $f50bd1f2915ed0f2$var$controlServings = function(newServings) {
    // let's update the recipe serving size (in the state).  The underlying data.  This will update the recipeView as well since this is impacted by clicking + or -
    $0f1d4402dffacf5b$export$5e23f4642ecad5ea(newServings);
    // update the recipe view
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
};
const $f50bd1f2915ed0f2$var$controlAddBookmark = function() {
    if (!$0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked) $0f1d4402dffacf5b$export$72009cc673d27d80($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
    else $0f1d4402dffacf5b$export$136048bcb9946c75($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.id);
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
};
const $f50bd1f2915ed0f2$var$controlBookmarks = function() {
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
};
const $f50bd1f2915ed0f2$var$controlAddRecipe = async function(newRecipe) {
    // show an error on the View if there is an error with try/catch
    // since the model of uploadRecipe is async, there has to be an await in here.
    try {
        (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).renderSpinner();
        await $0f1d4402dffacf5b$export$d660c2254e74960d(newRecipe);
        console.log($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
        (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).renderMessage();
        (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
        // this will change the id in the url, so use the history API.  Then we call the pushState method which changes the URL without re-loading the page.  It takes 3 arguments, and only the 3rd one is important since it's the URL
        window.history.pushState(null, "", `#${$0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.id}`);
        // this will close the form window with toggleWindow, a public function.  Give it 2.5 seconds.
        setTimeout(function() {
            (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).toggleWindow();
        }, (0, $ba30e20475feac5a$export$3ce8858248d89a69) * 1000);
    } catch (err) {
        console.error(err);
        (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).renderError(err.message);
    }
};
// publisher/subscriber pattern
const $f50bd1f2915ed0f2$var$init = function() {
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$controlBookmarks);
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$controlRecipes);
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).addHandlerUpdateServings($f50bd1f2915ed0f2$var$controlServings);
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).addHandlerAddBookmark($f50bd1f2915ed0f2$var$controlAddBookmark);
    (0, $813cf99795e9ec97$export$2e2bcd8739ae039).addHandlerSearch($f50bd1f2915ed0f2$var$controlSearchResults);
    // this will call the function in paginationView, which will in turn call addEventListner, so we can start listening fo r the click event on the pagination element.
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).addHandlerClick($f50bd1f2915ed0f2$var$controlPagination);
    (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).addHandlerUpload($f50bd1f2915ed0f2$var$controlAddRecipe);
};
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.413c67a8.js.map
